<template>
  <div class="categories">
    <div class="category-form">
      <input 
        v-model="newCategory" 
        placeholder="새 지출 항목"
        @keyup.enter="addCategory"
        :disabled="loading"
      >
      <button @click="addCategory" :disabled="loading">추가</button>
    </div>
    <div v-if="error" class="error-message">{{ error }}</div>
    <ul class="category-list">
      <li v-for="category in categories" :key="category.id" class="category-item">
        <div v-if="editingId === category.id" class="edit-form">
          <input 
            v-model="editingName" 
            @keyup.enter="updateCategory(category.id)"
            @keyup.esc="cancelEdit"
          >
          <button @click="updateCategory(category.id)" class="btn-save">저장</button>
          <button @click="cancelEdit" class="btn-cancel">취소</button>
        </div>
        <div v-else class="category-content">
          <span>{{ category.name }}</span>
          <div class="category-actions">
            <button @click="startEdit(category)" class="btn-edit">수정</button>
            <button @click="deleteCategory(category.id)" class="btn-delete">삭제</button>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { expenseStore } from '../store/expense'

export default {
  name: 'ExpenseCategories',
  data() {
    return {
      newCategory: '',
      editingId: null,
      editingName: '',
      loading: false,
      error: null
    }
  },
  computed: {
    categories() {
      return expenseStore.categories.value
    }
  },
  methods: {
    async addCategory() {
      if (!this.newCategory.trim() || this.loading) return

      try {
        this.loading = true
        await expenseStore.addCategory(this.newCategory)
        this.newCategory = ''
      } catch (error) {
        this.error = '카테고리 추가 실패'
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    startEdit(category) {
      this.editingId = category.id
      this.editingName = category.name
    },
    async updateCategory(id) {
      if (!this.editingName.trim() || this.loading) return

      try {
        this.loading = true
        await expenseStore.updateCategory(id, this.editingName)
        this.cancelEdit()
      } catch (error) {
        this.error = '카테고리 수정 실패'
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    cancelEdit() {
      this.editingId = null
      this.editingName = ''
    },
    async deleteCategory(id) {
      if (!confirm('이 카테고리를 삭제하시겠습니까?') || this.loading) return

      try {
        this.loading = true
        await expenseStore.deleteCategory(id)
      } catch (error) {
        this.error = '카테고리 삭제 실패'
        console.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.categories {
  padding: 0;
  background: none;
}

.category-form {
  margin-bottom: 20px;
  display: flex;
  gap: 8px;
}

.category-form input {
  padding: 8px;
  flex: 1;
  font-size: 16px;
}

.category-form button {
  padding: 8px 16px;
  font-size: 16px;
}

.category-list {
  list-style: none;
  padding: 0;
}

.category-item {
  padding: 12px;
  margin-bottom: 8px;
  background-color: white;
  border-radius: 4px;
  font-size: 16px;
}

.category-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.category-actions {
  display: flex;
  gap: 8px;
}

.edit-form {
  display: flex;
  gap: 8px;
}

.edit-form input {
  flex: 1;
  padding: 4px 8px;
}

button {
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.btn-edit {
  background-color: #4CAF50;
  color: white;
}

.btn-delete {
  background-color: #f44336;
  color: white;
}

.btn-save {
  background-color: #2196F3;
  color: white;
}

.btn-cancel {
  background-color: #9e9e9e;
  color: white;
}

button:hover {
  opacity: 0.8;
}

.error-message {
  color: #f44336;
  margin-bottom: 10px;
}

/* 모바일 최적화 */
@media (max-width: 600px) {
  .categories {
    padding: 15px;
  }

  .category-form input {
    padding: 12px;
    font-size: 18px;
  }

  .category-form button {
    padding: 12px 20px;
    font-size: 18px;
  }

  .category-item {
    padding: 15px;
    font-size: 18px;
  }

  .edit-form input {
    font-size: 18px;
    padding: 12px;
  }

  .edit-form button {
    font-size: 18px;
    padding: 12px;
  }

  .category-actions button {
    font-size: 18px;
    padding: 10px 15px;
  }
}
</style> 